<!-- 删除确认提示 -->

<template>
	<div class="del_notice_out_box">
		<el-dialog v-model="info.isshow">
			<div class="tt">{{$t("提示")}}</div>
			<img
				src="@/assets/images/40.png"
				alt=""
				class="close"
				@click="info.cancel"
			>

			<div class="desc">
				<img
					src="@/assets/images/100.png"
					alt=""
				>
				<span>{{ info.content }}</span>
			</div>

			<div class="btns_box">
				<div
					class="cancel"
					@click="info.cancel"
				>{{$t("取消")}}</div>
				<div
					class="confirm"
					@click="info.confirm"
				>{{$t("确认")}}</div>
			</div>
		</el-dialog>
	</div>
</template>


<script lang="ts" setup>
/**
 * 确认框
 * @example <DelConfrim ref="delConfrim" />
 * 			import DelConfrim from "@/components/DelConfrim.vue"
 * 			import { DelConfrimType } from '@/types/global';
 * 			const delConfrim = ref(null)
 * 			delConfrim.value.show("",()=>{})
 */

import { reactive, defineExpose } from 'vue';
import { DelConfrimType } from '@/types/global';

const info = reactive({
	isshow: false,
	content: '',
	confirmBakc: () => {
		console.debug('');
	},
	cancelBack: () => {
		console.debug('');
	},

	cancel() {
		info.isshow = false;
		info.cancelBack && info.cancelBack();
	},
	confirm() {
		info.isshow = false;
		info.confirmBakc && info.confirmBakc();
	}
});

function show(content, confirmBakc, cancelBack) {
	info.content = content;
	info.confirmBakc = confirmBakc;
	info.cancelBack = cancelBack;
	info.isshow = true;
}

defineExpose<DelConfrimType>({ show });
</script>

<style lang="scss" scoped>
.del_notice_out_box {
	:deep(.el-dialog) {
		width: 520px;
		top: 15vh;
		border-radius: 8px;
		padding: 32px 24px;

		.el-dialog__header {
			display: none;
		}
	}

	.close {
		width: 16px;
		height: 16px;
		position: absolute;
		top: 28px;
		right: 24px;
		z-index: 1;
	}

	.tt {
		font-size: 24px;
		color: #333333;
		text-align: left;
		padding-bottom: 16px;
		border-bottom: 1px solid #eee;
	}

	.desc {
		padding: 42px 0 50px;
		font-size: 16px;
		color: #110c29;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 18px;
			height: 18px;
			margin-right: 16px;
			flex-shrink: 0;
		}
	}

	.btns_box {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;

		.confirm,
		.cancel {
			width: 144px;
			height: 48px;
			border-radius: 8px;
			margin: 0;
			border: none;
			outline: none;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		.cancel {
			color: #333;
			background: #f2f2f2;
		}

		.confirm {
			margin-left: 32px;
			color: #fff;
			background: linear-gradient(173deg, #6e94ff 0%, #3462e1 100%);
			box-shadow: 0px 2px 2px 1px rgba(32, 74, 191, 0.3),
				inset 0px 1px 1px 1px rgba(227, 239, 255, 0.36);
		}
	}
}
</style>